import appApi from '../../../../../api/app-api';
import { StudentCourseByStatusFilters } from '../side-bar-filter/student-course-by-status-side-bar-filter.type';
import { StudentStatusReportDb } from '../../../../../api/types/reports/student-status-report-result-db';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getStudentCourseByStatusOperation = async (
  filters: StudentCourseByStatusFilters,
  setLoading: (loading: boolean) => any,
  setRows: (rows: StudentStatusReportDb[]) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getStudentByStatusInCourseReport(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const bodyRes: StudentStatusReportDb[] = res.data.body;

    setLoading(false);

    setRows(bodyRes);
  } catch (e) {
    setLoading(false);
    console.error('Error fetching student course status report:', e);
    throw e;
  }
};
